import React from 'react';

export function sx(cssText: string): React.CSSProperties {
	const out: Record<string, string> = {};
	String(cssText || '')
		.split(';')
		.forEach((part) => {
			const i = part.indexOf(':');
			if (i < 0) {
				return;
			}
			const key = part.slice(0, i).trim();
			const val = part.slice(i + 1).trim();
			if (!key) {
				return;
			}
			if (key.startsWith('--')) {
				out[key] = val;
				return;
			}
			const camel = key.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
			out[camel] = val;
		});
	return out as React.CSSProperties;
}

export function onGmMouseOver(e: React.MouseEvent) {
	const t = (e.target as HTMLElement).closest('.gmHover') as HTMLElement | null;
	if (!t || t.dataset.gmPrev != null) {
		return;
	}
	const hover = t.getAttribute('data-hover');
	if (!hover) {
		return;
	}
	t.dataset.gmPrev = t.getAttribute('style') || '';
	Object.assign(t.style, sx(hover));
}

export function onGmMouseOut(e: React.MouseEvent) {
	const t = (e.target as HTMLElement).closest('.gmHover') as HTMLElement | null;
	if (!t || t.dataset.gmPrev == null) {
		return;
	}
	const rel = e.relatedTarget as Node | null;
	if (rel && t.contains(rel)) {
		return;
	}
	t.setAttribute('style', t.dataset.gmPrev);
	delete t.dataset.gmPrev;
}
